import { createSelector } from 'reselect'

const selectShowPopup = (state) => state.settings.deepfakeGeneral.self.showPopup
const selectSendWarningReportNotification = (state) =>
  state.settings.deepfakeGeneral.self.sendWarningReportNotification
const selectSwitchersLoader = (state) => state.settings.deepfakeGeneral.self.switchersLoader
const selectEmployeeInfo = (state) => state.settings.deepfakeGeneral.self.employeeInfo
const selectMailboxData = (state) => state.settings.deepfakeGeneral.self.mailboxData
const selectKeyMembersData = (state) => state.settings.deepfakeGeneral.self.keyMembersData
const selectKeyMemberLoader = (state) => state.settings.deepfakeGeneral.self.keyMemberLoader
const selectKeyMemberError = (state) => state.settings.deepfakeGeneral.self.keyMemberError
const selectWarningReportRecipients = (state) =>
  state.settings.deepfakeGeneral.self.warningReportRecipients
const selectSelectedRecipientId = (state) => state.settings.deepfakeGeneral.self.selectedRecipientId
const selectCandidatesLoader = (state) => state.settings.deepfakeGeneral.self.candidatesLoader
const selectCandidates = (state) => state.settings.deepfakeGeneral.self.candidates
const selectWarningReportRecipientsLoader = (state) =>
  state.settings.deepfakeGeneral.self.warningReportRecipientsLoader
const selectCandidatesOptions = createSelector(selectCandidates, (candidates) =>
  candidates.map(({ userId, recipientFirstName, recipientLastName }) => ({
    label: `${recipientFirstName} ${recipientLastName}`,
    value: userId,
  }))
)
const selectAllowListData = (state) => state.settings.deepfakeGeneral.self.allowListData
const selectAddAllowListLoader = (state) => state.settings.deepfakeGeneral.self.addAllowListLoader
const selectAddAllowListError = (state) => state.settings.deepfakeGeneral.self.addAllowListError
const selectDeleteAllowListLoader = (state) =>
  state.settings.deepfakeGeneral.self.deleteAllowListLoader

export {
  selectShowPopup,
  selectSendWarningReportNotification,
  selectSwitchersLoader,
  selectEmployeeInfo,
  selectMailboxData,
  selectKeyMembersData,
  selectKeyMemberLoader,
  selectKeyMemberError,
  selectWarningReportRecipients,
  selectCandidatesLoader,
  selectCandidates,
  selectCandidatesOptions,
  selectSelectedRecipientId,
  selectWarningReportRecipientsLoader,
  selectAllowListData,
  selectAddAllowListLoader,
  selectAddAllowListError,
  selectDeleteAllowListLoader,
}
